// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__21-k0","info":"PatientInfo_info__3S4xD"};